import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconAnimateDirective } from './icon-animate/icon-animate.directive';
import { NumberAnimateDirective } from './number-animate/number-animate.directive';

const COMPONENTS = [IconAnimateDirective, NumberAnimateDirective];

@NgModule({
  imports: [CommonModule],
  declarations: [COMPONENTS],
  exports: [COMPONENTS],
})
export class AtaraxiaAnimateModule {}
